/**
 * Utility function to get the correct image URL
 * Handles both Cloudinary URLs (absolute) and legacy local paths (relative)
 * 
 * @param {string} imagePath - The image path from database
 * @returns {string|null} - The full URL to the image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If it's already a full URL (Cloudinary, etc), return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Otherwise, prefix with backend URL for legacy local paths
  return `${process.env.REACT_APP_BACKEND_URL}${imagePath}`;
};

/**
 * Utility function specifically for profile images
 * Returns a placeholder avatar if no image is set
 */
export const getProfileImageUrl = (imagePath, userName = '') => {
  const url = getImageUrl(imagePath);
  if (url) return url;
  
  // Return null - let component handle placeholder
  return null;
};

/**
 * Utility function for club logos
 * Falls back to default logo if none set
 */
export const getClubLogoUrl = (logoUrl, imageUrl) => {
  const url = getImageUrl(logoUrl || imageUrl);
  if (url) return url;
  
  // Return default logo
  return '/assets/baremc-logo-transparent.png';
};
